import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils'

const P = styled.p`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 150%;
  color: ${color('primary')};
  margin: 1rem 0;
  text-align: center;

  a {
    cursor: pointer;
    color: ${color('blue400')};
  }
`

const UpgradePrompt = ({ onUpgrade }) => (
  <P>
    <a onClick={onUpgrade}>
      <I18n data={messages.withdrawal_upgrade} />
    </a>
  </P>
)

export default UpgradePrompt
